import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import SotyBadge from './soty-badge';

import { Award } from '../../../../types';

import * as S from './styles';

type OwnProps = {
  className?: string;
  size?: number;
  sotyBadge: Award;
};

const SotyBadgeLink = ({ className, size, sotyBadge }: OwnProps) => {
  const { linkTo } = useContext(AppContext);

  const sotyLink = linkTo('shopOfTheYearWinners', {
    year: sotyBadge.year,
  });

  return (
    <S.SotyBadge to={sotyLink} className={className}>
      {sotyBadge.logo && (
        <SotyBadge
          imgUrl={sotyBadge.logo}
          name={sotyBadge.name}
          size={size}
          year={sotyBadge.year?.toString()}
        />
      )}
    </S.SotyBadge>
  );
};

export default SotyBadgeLink;
